import * as tf from "@tensorflow/tfjs";

export function processTfjsYOLOOutput(outputTensor, confThreshold = 0.5,numClasses = 5, ) {
    const output_values = tf.transpose(outputTensor, [0, 2, 1])
    const [, numAnchors, stride] = output_values.shape; // 1x8400x9
    const output = output_values.dataSync(); // Convert Tensor to a flat array

    const bboxes = [];

    for (let i = 0; i < numAnchors; i++) {
        const index = i * stride;
        const box = output.slice(index,index+stride)

        const classScores = box.slice(4, stride); // Extract class scores

        // Find the best class & confidence score
        const maxClassScore = Math.max(...classScores); // Get highest score
        const classId = classScores.indexOf(maxClassScore); // Get class index

        // Apply confidence threshold
        if (maxClassScore >= confThreshold) {
            // Extract bounding box (absolute coordinates in input image)
            let cx = output[index];     // Center x (absolute)
            let cy = output[index + 1]; // Center y (absolute)
            let width = output[index + 2];  // Width (absolute)
            let height = output[index + 3]; // Height (absolute)
            // Convert center coordinates to top-left coordinates
            const x1 = cx - (width / 2);
            const y1 = cy - (height / 2);
            const x2 = x1+width
            const y2 = y1+height
            // Extract class scores (last 5 values)
            bboxes.push({bbox:[x1,y1,x2,y2],class:classId, confidence:maxClassScore});
        }
        tf.dispose([box,classScores]);
    }
    const final_boxes = nms(bboxes,0.5)
    tf.dispose([outputTensor, output_values,output,bboxes]);
    return final_boxes;
}

export async function processFaceYOLOOutput(outputTensor, org_width,org_height, numClasses = 1, confThreshold = 0.5) {
    const output_values = tf.transpose(outputTensor, [0, 2, 1])
    const [, numAnchors, stride] = output_values.shape; // 1x8400x9
    const output = output_values.dataSync(); // Convert Tensor to a flat array

    const bboxes = [];

    for (let i = 0; i < numAnchors; i++) {
        const index = i * stride;
        const box = output.slice(index,index+stride)

        const classScores = box.slice(4, stride); // Extract class scores

        // Find the best class & confidence score
        const maxClassScore = Math.max(...classScores); // Get highest score
        const classId = classScores.indexOf(maxClassScore); // Get class index

        // Apply confidence threshold
        if (maxClassScore >= confThreshold) {
            // Extract bounding box (absolute coordinates in input image)
            let cx = output[index];     // Center x (absolute)
            let cy = output[index + 1]; // Center y (absolute)
            let width = output[index + 2];  // Width (absolute)
            let height = output[index + 3]; // Height (absolute)
            // cx = (cx / 640) * org_width
            // cy = (cy / 640) * org_height
            // width = (width / 640) * org_width
            // height = (height / 640) * org_height
            
            // Convert center coordinates to top-left coordinates
            const x1 = cx - (width / 2);
            const y1 = cy - (height / 2);
            const x2 = x1+width
            const y2 = y1+height
            // Extract class scores (last 5 values)
            bboxes.push({bbox:[x1,y1,x2,y2],class:classId, confidence:maxClassScore});
        }
    }
    const final_boxes = nms(bboxes,0.5)

    return final_boxes;
}
function nms(bboxes, iouThreshold) {
    if (bboxes.length === 0) return [];

    // Sort boxes by confidence (highest first)
    bboxes.sort((a, b) => b.confidence - a.confidence);

    const selectedBoxes = [];

    while (bboxes.length > 0) {
        const bestBox = bboxes.shift(); // Pick the highest confidence box
        selectedBoxes.push(bestBox);

        // Filter out boxes with high IoU (same class)
        bboxes = bboxes.filter(box => 
            box.class !== bestBox.class || iou(bestBox.bbox, box.bbox) < iouThreshold
        );
    }

    return selectedBoxes;
}

// IoU calculation function
function iou(bboxA, bboxB) {
    const [x1A, y1A, x2A, y2A] = bboxA;
    const [x1B, y1B, x2B, y2B] = bboxB;

    const x1 = Math.max(x1A, x1B);
    const y1 = Math.max(y1A, y1B);
    const x2 = Math.min(x2A, x2B);
    const y2 = Math.min(y2A, y2B);

    const intersection = Math.max(0, x2 - x1) * Math.max(0, y2 - y1);
    const areaA = (x2A - x1A) * (y2A - y1A);
    const areaB = (x2B - x1B) * (y2B - y1B);
    const union = areaA + areaB - intersection;

    return union > 0 ? intersection / union : 0;
}

// export const yolo_classes = ['Face'];
// export const color_map = ["#34A56F"];
export const yolo_classes = ['container'];
// export const yolo_classes = ['Rebuig', 'Organic', 'Vindre', 'Envasos', 'Paper'];
export const color_map = ["#52595D", "#FF6700","#34A56F",'#FFFF33','#0000FF'];